import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';
import SitewideSchema from './SitewideSchema';

export default function Layout({ children, location }) {
  return (
    <div className="text-ink-muted font-sans antialiased relative selection:bg-accent-fill selection:text-on-accent">
      <SitewideSchema location={location} />

      {/* Scroll restoration */}
      <ScrollToTop location={location} />

      {/* Ambient Background Engine */}
      <div className="ambient-bg">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="blob blob-3"></div>
        <div className="blob blob-4"></div>
        <div className="blob blob-5"></div>
        <div className="blob blob-6"></div>
        <div className="blob blob-7"></div>
        <div className="blob blob-8"></div>
      </div>

      {/* Grain Texture */}
      <div className="texture-overlay"></div>

      {/* Skip navigation — first DOM element so it's the first tab stop */}
      <a href="#main-content" className="skip-to-content">Skip to main content</a>

      {/* Navigation */}
      <Navigation location={location} />

      {/* Skip target — placed before page content so the skip link lands here */}
      <span id="main-content" tabIndex={-1} aria-hidden="true" style={{ position: 'absolute', top: 0 }} />

      {/* Page Content */}
      {children}

      {/* Footer */}
      <Footer />
    </div>
  );
}
